<template>
    <TopNav></TopNav>
		<h1>Average Calculator</h1>
		<fieldset>
      <legend>Average Calculator</legend>
      <label for="numbersField">Numbers:</label>
      <textarea v-model.number="numbers" @input="onNumbersChange" autofocus id="numbersField" rows="4" cols="40" >
      </textarea>
			<br><br>
      Average: <span class="blue">{{averageFormatted}}</span>
		</fieldset>
</template>

<script>
import TopNav from './components/TopNav.vue'

export default {
  name: "Average",
  data() {
    return {
      formatter: new Intl.NumberFormat('en-US', {
        maximumFractionDigits: 4
      }),
      numbers: "10, 9, 11",
      averageFormatted: 10
    }
  },
  components: {
    TopNav
  },
  methods: {
    onNumbersChange(e) {
      let numbersArray = e.currentTarget.value.match(/[0-9.]+/g);
      numbersArray = numbersArray.map(Number);
      let average = numbersArray.reduce((a, b) => a + b) / numbersArray.length;
      this.averageFormatted = this.formatter.format(average);
    },
  },
};
</script>

<style>
*, *:before, *:after {
  box-sizing: border-box;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}

body {
  margin: 1em auto;
  margin-top: 0;
  max-width: 40em;
  font-family: Arial, Helvetica, sans-serif;
}

label {
  display: inline-block;
  width: 110px;
}

textarea {
  vertical-align: top;
  width: 100%;
}

footer section a {
  margin: 20px;
}

.blue {
  color: blue;
}
</style>
